import React from 'react';
import styled from 'styled-components';

interface Props {
    label: string;
}

export const DashedSeparator = ({ label }: Props) => {
    return (
        <Container>
            <DashedLine />
            <Label>{label}</Label>
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    margin: 24px 0 16px 0;
    text-align: center;
    z-index: 0;
`;

const Label = styled.span`
    padding: 0 24px;
    background-color: ${({ theme }) => theme.container.primaryBackground};
    color: ${({ theme }) => theme.text.subtle};
    text-transform: $uppercase;
`;

const DashedLine = styled.div`
    position: absolute;
    top: 50%;
    width: 100%;
    height: 1px;
    background-size: 20px 1px;
    background-repeat: repeat-x;
    background-image: linear-gradient(
        to right,
        ${({ theme }) => theme.colors.cocoa200} 0%,
        ${({ theme }) => theme.colors.cocoa200} 50%,
        transparent 50%
    );
    z-index: -1;
`;
